import { FiShieldOff } from "react-icons/fi";
import useTranslator from "../../hooks/useTranslator";
import { DownloadIcon } from "../../helper/svgHelper";

const DecisionCard = ({
  decisionTitle,
  decisionStatus,
  combinedIncome,
  combinedEffortRate,
  decisionSummary,
  insurable,
  recommendedActions,
  children,
  currentLang,
  preFilledInsuranceDocument,
}) => {
  // Determine the status class for styling
  const { _t } = useTranslator();
  const getStatusClass = () => {
    if (typeof decisionStatus === "string") {
      const lowerStatus = decisionStatus.toLowerCase();
      if (lowerStatus === "approved") return "approved";
      if (lowerStatus === "rejected") return "rejected";
      return "conditional";
    }
    return "conditional";
  };

  const statusClass = getStatusClass();

  return (
    <section className={`linked-report__decision-card ${statusClass}`}>
      <div className="linked-report__decision-title-row">
        <div className="linked-report__decision-title">{decisionTitle}</div>
        {insurable !== null && insurable !== undefined && (
          <span
            style={{
              color: insurable ? "#82CF3F" : "#FF3C3C",
              backgroundColor: insurable ? "#F2FBE9" : "#FFE2E2",
              border: insurable ? "none" : "1px solid #EB9B9C",
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
            }}
            className="report-overview__badge"
          >
            {insurable ? (
              <img src={"/images/shield.svg"} alt="" />
            ) : (
              <FiShieldOff className="report-overview__badge-icon" size={14} />
            )}
            {insurable ? _t("insurable") : _t("notInsurable")}
            {insurable && preFilledInsuranceDocument && (
              <a
                href={`${process.env.REACT_APP_CDN_ENDPOINT}/${process.env.REACT_APP_CDN_CONTAINER}/${preFilledInsuranceDocument}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
                className="download-icon-wrapper"
                style={{ color: "inherit", lineHeight: 0 }}
              >
                <DownloadIcon />
              </a>
            )}
          </span>
        )}
      </div>
      <div className="linked-report__decision-metrics">
        <strong>{`€${Math.round(combinedIncome || 0)}/${_t("mo")}`}</strong>
        <span>•</span>
        <strong>{`${_t("effortRate")} ${combinedEffortRate}`}</strong>
      </div>
      {decisionSummary && (
        <p className="linked-report__decision-description">
          {typeof decisionSummary === "string"
            ? decisionSummary
            : decisionSummary[currentLang]?.split("\n")?.join(" ") ||
              "This tenant nearly meets the criteria for automatic approval."}
        </p>
      )}
      {children}
    </section>
  );
};

export default DecisionCard;
